// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kmf7","label":"styles_label__3n8b_"};